import ShareVideo from "@/screens/ShareVideo";

const Index = ({
  newsData = null,
}) => {
  return (
    <>
      <ShareVideo newsData={newsData}/>
    </>
  );
};


export default Index;

export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  try {
    const { slug } = ctx.params;
    // let currentPath = ctx?.resolvedUrl;

    const { getVideoEmbedById } = await import(
      "@/handlers/content"
    );
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getEmbedId } = await import("@/utils/url");
    const contentId = getEmbedId(slug);

    //* get redis api key for each api
    const storyRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_VIDEO",
      params: {
        api: "videoembeddetail",
        id: contentId,
      },
    });

    let newsData = null;

    [newsData] = await Promise.all([
      fetchRedisWrapper(storyRedisKey, () =>
      getVideoEmbedById({
          id: contentId,
        })
      ),
    ]);

    if (!newsData || Object.keys(newsData)?.length === 0) {
      return {
        notFound: true,
      };
    }

    const headerCache = newsData?.cache;
    setPageTTL(ctx, headerCache?.akamai_ttl);

    return {
      props: {
        newsData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
